import React, {useState} from 'react'
import {NavLink, Route, Router, Switch, Redirect} from "react-router-dom";
import AdminDataUploads from "./AdminDataUploads/AdminDataUploads";
import AdminInviteHost from "./AdminDataUploads/AdminInviteHost/AdminInviteHost";
import AdminViewHost from "./AdminDataUploads/AdminHosts/AdminViewHost";
import AdminGuestInvitation from "./AdminGuestInvitation/AdminGuestInvitation";
import AdminUploadValidation from "./AdminGuestInvitation/AdminUploadValidation";
import AdminValidate from "./AdminGuestInvitation/AdminValidate";
import AdminRegistration from "./AdminRegistration/AdminRegistration";
import AdminViewRegistration from "./AdminRegistration/AdminViewRegistration";
import AdminViewGuest from "./AdminRegistration/AdminViewGuest";
import Layout from "~/Admin/Layout/Layout";
import TopMenu from '../Layout/TopMenu/TopMenu';
import AdminCommsManagement from './AdminRegistration/AdminCommsManagement';
import AdminGuestAll from './AdminGuestAll/AdminGuestAll';

const AdminGuests = ({match, ...props}) => {

    return (
        <Layout>

            <h1>Guest Management</h1>

            <TopMenu>
                <NavLink
                    activeClassName="active"
                    to={`${match.path}/all`}>
                    All Guests
                </NavLink>
                <NavLink
                    activeClassName="active"
                    to={`${match.path}/invitation`}>
                    Guest Invitation
                </NavLink>
                <NavLink
                    activeClassName="active"
                    to={`${match.path}/registration`}>
                    Registration management
                </NavLink>
                <NavLink
                    activeClassName="active"
                    to={`${match.path}/comms`}>
                    Comms Management
                </NavLink>
                {/* <NavLink
                    activeClassName="active"
                    to={`${match.path}/uploads`}>
                    Host Uploads
                </NavLink> */}
            </TopMenu>

            <div className="content mt-5">
                {/* <Route path={`${match.path}/uploads`} component={AdminDataUploads} />               // REQUESTED REMOVE LDT-2312 */}
                {/* <Route exact path={`${match.path}/hosts/invite`} component={AdminInviteHost} />     // REQUESTED REMOVE LDT-2312 */}
                {/* <Route exact path={`${match.path}/hosts/:id(\\d+)`} component={AdminViewHost} />    // REQUESTED REMOVE LDT-2312 */}

                <Route exact path={`${match.path}/all`} component={AdminGuestAll} />
                <Route exact path={`${match.path}/all/:id(\\d+)`} component={AdminViewRegistration} />

                <Route exact path={`${match.path}/invitation`} component={AdminGuestInvitation} />
                <Route exact path={`${match.path}/invitation/validate`} component={AdminUploadValidation} />
                <Route exact path={`${match.path}/invitation/validate/:id(\\d+)`} component={AdminValidate} />

                <Route exact path={`${match.path}/registration`} component={AdminRegistration} />
                <Route exact path={`${match.path}/registration/:id(\\d+)`} component={AdminViewRegistration} />
                <Route exact path={`${match.path}/registration/:id(\\d+)/guest/:guest_id(\\d+)`} component={AdminViewGuest} />

                <Route exact path={`${match.path}/comms`} component={AdminCommsManagement}/>
            </div>

        </Layout>
    );
}

export default AdminGuests;
